import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热播推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选当前最受欢迎的热播电视剧，高清画质流畅播放，每日同步更新
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <a
              key={item.id}
              href={item.link}
              className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-xs font-medium text-background-50 bg-primary-500/90 rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 text-xs text-background-50/90">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-950 mb-1 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500 bg-secondary-100/50 px-2 py-0.5 rounded">
                  {item.category}
                </span>
                <p className="text-xs text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}